<svelte:options tag="svelte-popup" immutable="{true}"/>
<template lang='pug'>
  div
    +if('isOpen')
      #popup(on:click="{close}")
        .dialog
          .title {title}
          .content {content}
    button(on:click="{open}") OPEN
</template>

<script lang="ts">
  export let title: string;
  export let content: string;
  let isOpen: boolean = false;

  function open() {
    isOpen = true;
  }

  function close() {
    isOpen = false;
  }
</script>

<style lang="sass">
  #popup
    position: fixed
    background-color: rgba(0,0,0,0.3)
    width: 100vw
    height: 100vh
    top: 0
    left: 0

  .dialog
    background-color: white
    width: 80vw
    margin: 100px auto 0 auto
    padding: 10px
    border-radius: 5px

  .title
    font-weight: bold
</style>
